<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">积分商城商品管理—查看（礼券）</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   @click="Searchlook">查看兑换记录</el-button>
        <el-button class="iconfont icon-fanhui"
                   @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <!-- 表单 -->
        <div>
          <el-form size="small"
                   :label-position="labelPosition"
                   label-width="100px">
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库"
                              class="boxsize">
                  <el-input v-model="acceptList.couponsName"
                            readonly
                            @click.native="acceptLustover">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品名称">
                  <el-input v-model="acceptList.commodityName"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="商品详情">
                  <!-- <el-input type="textarea"
                            v-model="acceptList.commDetail"
                            :disabled="true"></el-input> -->
                  <editor v-model="acceptList.commDetail"
                          :min-height="192" />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="轮播图">
                  <img width="45%"
                       v-for="(item,index) in imagesArray"
                       :key="index"
                       :src="item"
                       style="margin:10px" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="总库存">
                  <el-input v-model="acceptList.stockQty"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最大兑换数量">
                  <el-input :disabled="true"
                            v-model="acceptList.maxNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="兑换日期">
                  <el-row>
                    <el-col :span="11">
                      <el-date-picker type="date"
                                      placeholder=""
                                      v-model="acceptList.startDate"
                                      style="width: 100%"
                                      :disabled="true"></el-date-picker>
                    </el-col>
                    <el-col class="line"
                            style="text-align: center"
                            :span="2">至</el-col>
                    <el-col :span="11">
                      <el-date-picker type="date"
                                      placeholder=""
                                      v-model="acceptList.endDate"
                                      style="width: 100%"
                                      :disabled="true"></el-date-picker>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换积分">
                  <el-input :disabled="true"
                            v-model="acceptList.creditPoint"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="限制销售等级">
                  <el-checkbox label="限制"
                               name="type"
                               v-model="acceptList.allUser"
                               :disabled="true"> </el-checkbox>
                  <el-checkbox-group v-model="checkedCities"
                                     :disabled="true">

                    <div style="width: 200px; border: 1px solid #ccc">
                      <div style="margin-left: 20px">
                        <div>
                          <el-checkbox v-for="item in checkList"
                                       :key="item.levelID"
                                       :label="item.levelID">
                            {{ item.levelName_cn }}
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="置顶排序">
                  <el-checkbox-group v-model="acceptList.top">
                    <div class="flex-between">
                      <el-checkbox name="type"
                                   :disabled="true">置顶</el-checkbox>
                      <el-input style="margin-left: 10px"
                                v-model="acceptList.topSortIndex"
                                :disabled="true"></el-input>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="允许兑换维护店" label-width="120px">
                  <el-radio-group v-model="acceptList.allServShop" :disabled="true">
                    <div style="display: flex;align-items: center;">
                      <el-radio :label="true">全部门店</el-radio>
                      <el-radio :label="false">部分门店</el-radio>
                    </div>
                  </el-radio-group>
                  <div style="padding-top: 20px;" v-if="!acceptList.allServShop">
                    <textarea
                    style="width: 100%; margin: 0px; padding: 0px"
                    :disabled="true"
                    rows="4"
                    readonly
                    v-model="acceptList.servOrgListStr"
                  ></textarea>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="核销提醒方式">
                  <el-radio-group v-model="acceptList.pubVeriCoupMode"
                                  :disabled="true">
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="到期提醒方式">
                  <el-radio-group v-model="acceptList.expirationMode"
                                  :disabled="true">
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3"> 公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="提前提醒">
                  <el-input style="width:130px"
                            v-model="acceptList.expirationTime"
                            :disabled="true" />
                  天
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item> </el-form-item>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- 查看兑换记录弹窗 -->
    <div class="record">
      <el-dialog width="60%"
                 title="查看兑换记录"
                 :visible.sync="recordVisible">
        <div class="buttonClass">
          <el-button icon="iconfont icon-chakan1"
                     @click="golookjump"
                     style="border:1px solid #b5b386">查询</el-button>
          <el-button icon="iconfont icon-chakan1"
                     @click="lookjump"
                     style="border:1px solid #b5b386;margin-left:30px;">查看</el-button>

        </div>
        <div>
          <el-form size="mini"
                   label-width="110px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="兑换记录编号">
                  <el-input v-model="rquerListNo.redemptionNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品类型">
                  <el-select style="width: 100%"
                             v-model="rquerListNo.commKind">
                    <el-option value=''
                               label="全部"></el-option>
                    <el-option v-for="item in optioncommkid"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="会员卡号\姓名">
                  <el-input v-model="rquerListNo.search"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="兑换日期">
                  <el-date-picker style="width: 40%"
                                  type="date"
                                  start-placeholder="开始日期"
                                  value-format="yyyy-MM-dd"
                                  v-model="rquerListNo.startRedemptionTime">
                  </el-date-picker>
                  至
                  <el-date-picker style="width: 50%;margin-left:15px"
                                  type="date"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd"
                                  v-model="rquerListNo.endRedemptionTime">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="POST领取单号">
                  <el-input v-model="rquerListNo.getNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="领取方式">
                  <el-select style="width: 100%"
                             v-model="rquerListNo.collectMethod">
                    <el-option v-for="item in optionkid"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-select style="width: 100%"
                             v-model="rquerListNo.state">
                    <el-option value=""
                               label="全部"></el-option>
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="tableDataList"
                    tooltip-effect="dark"
                    v-el-table-infinite-scroll="true"
                    infinite-scroll-disabled="true">
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-radio v-model="radio"
                          :label="scope.$index"
                          @change.native="handleRadioChange(scope.row)">&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="redemptionNo"
                             label="兑换记录编号">
            </el-table-column>
            <el-table-column prop="commKind"
                             label="类型">
              <template slot-scope="scope">
                {{scope.row.commKind === '0' ? '礼券':'' ||
                scope.row.commKind ==='1' ? '礼物':'' ||
                 scope.row.commKind ==='2' ? '券包':''}}
              </template>
            </el-table-column>
            <el-table-column prop="state"
                             label="状态">
              <template slot-scope="scope">
                {{scope.row.state === 0 ? '未领取':'' ||
                 scope.row.state ===1 ? '已领':''||
                     scope.row.state ===2 ? '废弃':''}}
              </template>
            </el-table-column>
            <el-table-column prop="custName"
                             label="会员"> </el-table-column>
            <el-table-column prop="creditPoint"
                             label="商品积分"> </el-table-column>
            <el-table-column prop="qty"
                             label="兑换数量"> </el-table-column>
            <el-table-column prop="exchangeSumPoint"
                             label="兑换总积分"> </el-table-column>
            <el-table-column prop="redemptionTime"
                             label="兑换日期">
              <template slot-scope="scope">
                {{scope.row.redemptionTime | dateFormats}}
              </template>
            </el-table-column>
            <el-table-column prop="getTime"
                             label="领取日期">
              <template slot-scope="scope">
                {{scope.row.getTime | dateFormats}}
              </template>
            </el-table-column>
            <el-table-column prop="createUserName"
                             label="创建人"> </el-table-column>
            <el-table-column prop="createTime"
                             label="创建日期">
              <template slot-scope="scope">
                {{scope.row.createTime | dateFormats}}
              </template>
            </el-table-column>
            <el-table-column prop="updateUserName"
                             label="最后修改人"> </el-table-column>
            <el-table-column prop="updateTime"
                             label="最后修改日期">
              <template slot-scope="scope">
                {{scope.row.updateTime | dateFormats}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import { upperOrLowerview, lntegralqueryApi, customerlevelApi } from '@/api/Integralquery'
export default {
  name: "centre",
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      labelPosition: "right",
      recordVisible: false,
      value: "",
      form: {
        radio: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      ruleForm: {
        radio: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      // 内层弹窗数据
      tableDataList: [],
      rquerListNo: {
        pageNo: '1',
        pageSize: '50',
        commKind: '', //积分商品类型
        collectMethod: '',//领取方式
        getNo: '',//pos领取单号
        redemptionNo: '',//兑换编号
        search: '',//搜索内容
        startRedemptionTime: '', //开始兑换时间
        endRedemptionTime: '', //兑换结束时间
        state: ''
      },
      //查看接口参数
      acceptList: {
        allUser: '',
        creditPoint: '',
        startDate: '',
        endDate: '',
        maxNum: '',
        image1: "",
        image2: '',
        image3: '',
        commDetail: '',
        commodityName: '',
        couponsName: '',
        top: true,
        topSortIndex: ''
      },
      radio: '',
      //弹窗参数
      Forrecord: [],
      options: [{
        value: '0',
        label: '未领取'
      }, {
        value: '1',
        label: '已领'
      }, {
        value: '2',
        label: '废弃'
      }],
      optionkid: [{
        value: '1',
        label: '到店自取'
      }, {
        value: '2',
        label: '快递邮寄'
      }],
      optioncommkid: [{
        value: '0',
        label: '礼券'
      }, {
        value: '1',
        label: '礼品'
      }, {
        value: '2',
        label: '券包'
      }],
      checkList: [],
      checkedCities: [],
      handleRadioValue: [],
      imagesArray: []
    };
  },
  created () {
    this.certificatevent()
    // this.ForrecordLook()
    this.customermethods()

  },
  watch: {
    //窗口宽度变化
    screenWidth () {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },

  },
  mounted () {
    this.getELmentHeight(); //获取页面高度
  },
  methods: {
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory () {
      this.$router.go(-1); //返回上一层
    },
    //请求查看时数据
    async certificatevent () {
      let arr = ''
      if (this.$route.query.Info === undefined) {
        arr = this.$route.query.certificate
      } else {
        arr = this.$route.query.Info
      }
      await upperOrLowerview({ commodityID: arr }).then((res) => {
        this.acceptList = res.data
        // console.log('数据来了', this.acceptList);
        this.commodityqs = this.$route.query.certificate;
        this.acceptList.servOrgListStr = "";
        this.acceptList.servOrgList.forEach((item) => {
          this.acceptList.servOrgListStr += `${item.shopName}\n`;
        });
      })

      this.acceptList.commAllowLvlList.forEach(item => {
        // console.log(item);
        if (item.selectOption === true) {
          this.checkedCities.push(item.levelID)
        }
      });

      if (this.acceptList.image1 != null) {
        this.imagesArray.push(this.acceptList.image1)
      }
      if (this.acceptList.image2 != null) {
        this.imagesArray.push(this.acceptList.image2)
      }
      if (this.acceptList.image3 != null) {
        this.imagesArray.push(this.acceptList.image3)
      }
      this.acceptList.allUser = !this.acceptList.allUser
    },
    //内置弹窗数据请求
    async LookForecord () {
      let exChange = {
        pageNo: '1',
        pageSize: '50',
        commKind: this.rquerListNo.commKind, //积分商品类型
        collectMethod: this.rquerListNo.collectMethod,//领取方式
        getNo: this.rquerListNo.getNo,//pos领取单号
        redemptionNo: this.rquerListNo.redemptionNo,//兑换编号
        search: this.rquerListNo.search,//搜索内容
        startRedemptionTime: this.rquerListNo.startRedemptionTime, //开始兑换时间
        endRedemptionTime: this.rquerListNo.endRedemptionTime, //兑换结束时间
        state: this.rquerListNo.state,
        commodityID: this.acceptList.commodityID
      }
      await lntegralqueryApi(exChange).then((res) => {
        this.tableDataList = res.data.list
      })
    },
    // //查看兑换记录弹框
    // async ForrecordLook () {
    //   let Xuanyaolist = {
    //     pageNo: '1',
    //     pageSize: '50',
    //     commodityID: this.commodityqs
    //   }
    //   await lntegralqueryApi(Xuanyaolist).then((res) => {
    //     if (res.message === 'success') {
    //       this.tableDataList = res.data.list
    //     }
    //   })
    // },
    lookjump () {
      if(this.handleRadioValue == "") {
        this.$message("请选择记录查看!")
      }else{
        this.$router.push({
        path: '/PointsShopping',
        query: {
          restion: this.handleRadioValue.redemptionID
        }
      })
      }
      
    },
    //查询
    golookjump () {
      this.LookForecord()
    },
    //radio赋值
    handleRadioChange (val) {
      //  是表格单选选中的值
      this.handleRadioValue = val
      // console.log(this.handleRadioValue);
    },
    acceptLustover () {

      this.$router.push({
        path: 'ViewDetails',
        query: {
          mm: this.acceptList.couponsGrpID
        }
      })
    },
    Searchlook () {
      this.LookForecord()
      this.recordVisible = true
    },
    async customermethods () {
      await customerlevelApi().then((res) => {
        this.checkList = res.data
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.card-pagination {
  height: 50px;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border: none;
  color: #a19b59;
}
// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 兑换记录弹窗样式
  .record {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .buttonClass {
      color: #b5b386 !important;
      margin-left: 80%;
      margin-top: -10px;
      margin-bottom: 10px;
    }
  }
  .boxsize input {
    text-decoration: underline;
    color: blue;
  }
  .header-title {
    min-width: 250px;
    line-height: 50px;
    height: 50px;
  }
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  height: 50px;
}
.push-button {
  width: 140px;
  color: #a19b59;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.header-text1 {
  height: 3.5rem;
}
</style>
